var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.forms),function(form,index){return _c(_vm.getComponentName(form.input_type),{key:index,tag:"component",staticClass:"mt-4",attrs:{"form":form,"value":_vm.getValue(form)},on:{"setValue":_vm.setContentsValue}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }